<template>
  <div class="layout-container">
    <div class="top">
      <slot name="top"></slot>
    </div>
    <div class="main">
      <slot></slot>
    </div>
    <div class="bottom">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.layout-container {
  padding-bottom: 60px;
}
</style>